import React, { useState } from "react";
import { token, type, userid } from "../../../../component/common/AdminAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { URL } from "../../../common/Url";

function BulkUploadRoute(props) {
  const [fileUrl, setFileURL] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const addrouteAndRate = () => {
    setIsLoading(true);
    const data = new FormData();
    data.append("amdfile", fileUrl);
    data.append("user_id", userid);
    data.append("route_id", props.bulkUploadPrice.id);
    data.append("route_name", props.bulkUploadPrice.verdor_name);
    data.append("token", token);
    data.append("method", "upload");
    fetch(`${URL}route_pricelist.php`, {
      method: "POST",
      body: data,
    }).then((result) => {
      result.json().then((resp) => {
        console.log("resp", resp);
        if (resp.success === true) {
          seterror({
            errarStatus: true,
            errorMessage: resp.message,
            bgcolor: "alert alert-success",
          });
          window.scrollTo(0, 0);
        } else {
          seterror({
            errarStatus: true,
            errorMessage: resp.message,
            bgcolor: "alert alert-danger",
          });
          setIsLoading(false);
        }
      });
    });
  };

  const fileChangedHandler = (e) => {
    if (e.target.files[0]) {
      setFileURL(e.target.files[0]);
    }
  };

  return (
    <div
      className="modal fade"
      id="bulkuploadRoute"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalbulkupload"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLong">
              Upload Bulk Price for{" "}
              <span className="text-success">
                {props.bulkUploadPrice.verdor_name}{" "}
              </span>
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body row">
            <div className="col-md-12">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                  <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              ) : null}
            </div>
            <a
              className="mb-3 text-right d-block"
              download
              href="/routeSample.csv"
            >
              <FontAwesomeIcon icon={faDownload} /> Dowload Sample
            </a>
            <div className="form-group col-md-12">
              <input
                placeholder="Enter mcc"
                className="form-control"
                type="file"
                onChange={fileChangedHandler}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            {isLoading ? (
              <button type="button" className="btn btn-primary">
                Uploading.....
              </button>
            ) : (
              <button
                onClick={addrouteAndRate}
                type="button"
                className="btn btn-primary"
              >
                Bulk Upload
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BulkUploadRoute;
